import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, subDays } from "date-fns";
import "./AppDatePicker.css";

interface RangeDatePickerProps {
  onChange: (dates: [Date | null, Date | null]) => void;
  minDaysSub: number;
  maxDaysAdd: number;
  defaultStartDate: Date;
  defaultEndDate: Date;
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
  onChange,
  minDaysSub,
  maxDaysAdd,
  defaultStartDate,
  defaultEndDate,
}) => {
  const [startDate, setStartDate] = useState<Date | undefined>(defaultStartDate);
  const [endDate, setEndDate] = useState<Date | undefined>(defaultEndDate);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [newStartDate, newEndDate] = dates;
    setStartDate(newStartDate || undefined);
    setEndDate(newEndDate || undefined);
    onChange(dates);
  };

  return (
    <DatePicker
      selectsRange
      dateFormat="dd/MM/yyyy"
      startDate={startDate}
      endDate={endDate}
      onChange={handleDateChange}
      isClearable
      minDate={subDays(new Date(), minDaysSub)}
      maxDate={addDays(new Date(), maxDaysAdd)}
      locale="en-GB"
      className="pl-4 pr-8 py-1 border rounded-3xl"
    />
  );
};

export default RangeDatePicker;